import angular from 'angular';
import grid from 'angular-ui-grid';

import storageFilters from '../../components/filters/storage';
import categorySelect from '../../components/form/element/category/select';
import storageSelect from '../../components/form/element/storage/select';

export class ProductStoragesController {

  closeWindow: Function;
  deleteRow: Function;
  addRow: Function;

  error: Function;
  success: Function;

  data;
  options;
  grid;
  product;
  module;
  storage;

  /*@ngInject*/
  constructor($scope, Storage, WindowService, AlertMessageFactory) {
    this.Storage = Storage;
    this.scope   = $scope;
    this.storage = {};

    this.error           = AlertMessageFactory.error;
    this.success         = AlertMessageFactory.success;

    this.closeWindow     = WindowService.delItem;
    this.scope.deleteRow = this.deleteRow.bind(this);
    this.scope.addRow    = this.addRow.bind(this);
  }

  $onInit() {

    var storages = this.Storage.getStorages();
    this.module  = this.Storage.getModuleByService('Storage');
    this.product = this.data.product;

    this.scope.storage = this.storage;
    this.scope.module  = this.module;

    if( ! this.product.storages){
      this.product.storages = [];
    }

    this.options = {
      primaryKey: '_id',
      enableCellEdit: true,
      enableRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      noUnselect: true,
      rowEditWaitInterval: -1,
      data: this.product.storages,
      showGridFooter: true,
      gridFooterTemplate: '<div class="ui-grid-bottom-panel" style="text-align: center; padding: 2px 0px;">' + 
        //'<div class="row">' +
        
        //'<div class="col-sm-4">' + 
        '<category-select raw="true" no-style="true" module-id="grid.appScope.module._id" ng-model="grid.appScope.storage.categoryId"></category-select>' +
        //'</div>' + 

        //'<div class="col-sm-4">' + 
        '<storage-select raw="true" no-style="true" category-id="grid.appScope.storage.categoryId" ng-model="grid.appScope.storage.storageId"></storage-select>' +
        //'</div>' + 

        //'<div class="col-sm-4">' + 
        '<button type="button" ng-click="grid.appScope.addRow()">Добавить</button>' +
        //'</div>' + 

        //'</div>' + 
        '</div>',
      onRegisterApi: (gridApi) => {
        this.grid = gridApi;

        this.grid.edit.on.afterCellEdit(this.scope, (rowEntity, colDef, newValue, oldValue) => {
          
          if(oldValue  == newValue) {
            return false;
          }

          return this.Storage.saveProduct(this.product)
            .then(() => {
              
              this.product.storages.unshift({
                storageId: null,
                available: 0
              });

              this.grid.rowEdit.setRowsClean([rowEntity]);
            });
        });
      },
      columnDefs: [{
        displayName: '#',
        field: '_id',
        groupable: false,
        resizable: false,
        sortable: false,
        visible: false,
        width: 50
      }, {
        displayName: 'Место',
        field: 'storageId',
        groupable: true,
        resizable: true,
        sortable: true,
        visible: true,
        cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.getCellValue(row, col) | renderStorage"></div>',
        cellEditableCondition: function(){ return false; }
      }, {
        displayName: 'Доступно',
        field: 'available',
        groupable: false,
        resizable: false,
        sortable: false,
        visible: true,
        width: 120,
        cellEditableCondition: function(){ return false; }
      }, {
        displayName: '#',
        field: 'status',
        width: 50,
        cellTemplate: '<span style="padding:5px;"><a href="javascript:;" ng-show="row.entity._id" ng-click="grid.appScope.deleteRow(row.entity)"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></a></span>',
        cellEditableCondition: function(){ return false; },
      }]
    };
  }

  addRow() {
    if( ! this.storage.storageId){
      return this.error("Выберите место для хранения!");
    }

    this.product.storages.push(this.storage);

    return this.saveProduct();
  }

  deleteRow(storage) {
    var index = this.product.storages.indexOf(storage);
    if(index != -1){
      this.product.storages.splice(index, 1);

      return this.saveProduct();
    }
  }

  saveProduct() {
    return this.Storage.saveProduct(this.product)
      .then(() => {
        // @TODO: need normal messages
      })
      .catch(err => {
        console.error(err);
      });
  }

  close() {
    this.closeWindow(this.data.id);
  }
}

export default angular.module('storageApp.product.storages', [grid, storageFilters, categorySelect, storageSelect])
  .component('productStorages', {
    bindings: {data: '='},
    transclude: true,
    template: require('./product-storages.html'),
    controller: ProductStoragesController,
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/product-storages/product-storages.component.js